import { render, staticRenderFns } from "./lkuCompany.vue?vue&type=template&id=2431b068"
import script from "./lkuCompany.vue?vue&type=script&lang=js"
export * from "./lkuCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports